Footer.$inject = []
function Footer(){

}

export default Footer